// extracted by mini-css-extract-plugin
export var callCard = "_r4-0";
export var callMessageButton = "_r4-1";
export var helpIcon = "_r4-3";
export var helpIconContainer = "_r4-4";
export var verticalDivider = "_r4-2";